module.exports = __webpack_public_path__ + "0a2f94ce88a3c9f50d715dd1a3bcddc9.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/products/aa-t-grey.jpg
// module id = 824
// module chunks = 0